import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';
import splitNames from '../../../Utils/Patient'

class AppointmentOpportunityToExcel {
    exportExcel(data) {
        console.log(data);
        let option = {};  // la opción representa el archivo de Excel
        let sheetData = [];
        let appointmentOpportunityData = this.saveBoxes(data);
        /* for(let i=0;i<data.length; i++) {
            let boxesData = this.saveBoxes(data);
            sheetData.push(boxesData);
        } */

        console.log(sheetData);

        option.fileName = 'Oportunidad de Cita';  // nombre del archivo Excel (Maximo 31 caracteres)
        option.datas = [
            {
                sheetName: 'Oportunidad de Cita',  // nombre de la página de hoja en el archivo de Excel
                /*  sheetFilter: this.getFilterAndHeader(),
                 sheetHeader: this.getFilterAndHeader(), */
                //columnWidths: [20, 20],
                sheetData: appointmentOpportunityData.data  // Fuente de datos en archivo Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel

    }

    getFilterAndHeader() {
        let headers = {
            '1': "TIPO DOCUMENTO",
            '2': "NÚMERO DE DOCUMENTO",
            '3': "PRIMER APELLIDO",
            '4': "SEGUNDO APELLIDO",
            '5': "NOMBRES",
            '6': "FECHA NACIMIENTO",
            '7': "MEDICO",
            '8': "ACTIVIDAD",
            '9': "CLIENTE",
            '10': "FECHA ASIGNACION",
            '11': "HORA ASIGNACION",
            '12': "FECHA CITA",
            '13': "HORA CITA",
            '14': "DÍAS",
            '15': "TIPO DE CITA",
            '16': "FECHA ADMISIÓN",
            '17': "HORA ADMISIÓN",
        }
        return headers;
    }

    saveBoxes(dataAppointment) {

        let dataTable = [];
        let casillasVacias = this.generarCasillasVacias();
        //Titulos
        let CasillasTitulos = this.getFilterAndHeader();
        dataTable.push(CasillasTitulos);

        let classifiedServices = dataAppointment.reduce((acc, curr) => {
            const key = curr["cup"];
            const curGroup = acc[key] ?? [];
            return { ...acc, [key]: [...curGroup, curr] };
        }, {})

        console.log("classifiedServices", classifiedServices)

        Object.values(classifiedServices).forEach(service => {
            let accDays = 0;
            let sumDays = 0;
            let lengthDays = service.length;
            //Admisiones
            for (let i = 0; i < service.length; i++) {
                const fecha_solicitud = moment(service[i].fecha_solicitud);
                const fecha_asignacion = moment(service[i].fecha_asignacion);
                const diffDates = fecha_asignacion.diff(fecha_solicitud, 'days');
                accDays += 1;
                sumDays += diffDates;
                console.log(diffDates, sumDays, accDays)
                service[i].promDays = diffDates;

                let infoDetallada = this.generarInformacionDetallada(service[i]);
                dataTable.push(infoDetallada);
            }
            let prom = sumDays / lengthDays;
            console.log(prom, sumDays, lengthDays)
            let casillaEstadistica = this.generarCasillaEstadistica(prom);
            dataTable.push(casillaEstadistica);
            dataTable.push(casillasVacias);
        })


        dataTable.push(casillasVacias);

        let sheet = {
            data: dataTable
        }

        return sheet;
    }

    splitPatientName(name) {
        var arrName = name.split(" ");
        return arrName;
    }

    generarInformacionDetallada(data) {
        let casillas = {
            '1': data.tip_documento ?? "",
            '2': data.num_documento ?? "",
            '3': data.apellido1 ?? "",
            '4': data.apellido2 ?? "",
            '5': data.nombres ?? "",
            '6': !!data.fec_nacimiento ? moment(data.fec_nacimiento).format("DD-MM-YYYY") : "",
            '7': data.nombre_profesional ?? "",
            '8': data.nom_prodec ?? "",
            '9': data.nombre_tercero ?? "",
            '10': !!data.fecha_solicitud ? moment(data.fecha_solicitud).format("DD-MM-YYYY") : "",
            '11': !!data.fecha_solicitud ? moment(data.fecha_solicitud).format("HH:mm:ss") : "",
            '12': !!data.fecha_asignacion ? moment(data.fecha_asignacion).format("DD-MM-YYYY") : "",
            '13': !!data.fecha_asignacion ? moment(data.fecha_asignacion).format("HH:mm:ss") : "",
            '14': data.promDays ?? '0',
            '15': data.tipo_cita_agenda ?? "",
            '16': !!data.fecha_admision ? moment(data.fecha_asignacion).format("DD-MM-YYYY") : "",
            '17': data.hora_admision ?? "",
        }
        return casillas;
    }

    generarCasillasVacias() {
        let casillas = {
            '1': "",
            '2': "",
            '3': "",
            '4': "",
            '5': "",
            '6': "",
            '7': "",
            '8': "",
            '9': "",
            '10': "",
            '11': "",
            '12': "",
            '13': "",
            '14': "",
            '15': "",
            '16': "",
            '17': "",
        }
        return casillas;
    }

    generarCasillaEstadistica(promedio) {
        let casillas = {
            '1': "",
            '2': "",
            '3': "",
            '4': "",
            '5': "",
            '6': "",
            '7': "",
            '8': "",
            '9': "",
            '10': "",
            '11': "",
            '12': "",
            '13': "Promedio de días:",
            '14': promedio.toFixed(3),
            '15': "",
            '16': "",
            '17': "",
        }
        return casillas;
    }

}

export default new AppointmentOpportunityToExcel();